import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { toastr } from "react-redux-toastr"
import Versao from "./../services/versao"
import Ambiente from "./../services/ambiente"
import Spinner from 'react-bootstrap/Spinner';

import {
    ValidaAcesso
    , ShowUsuario
    , VersaoBackEndyy
    , AActEnviaEmail
    // , CarregaAcessoUsuarios
    // , getAcessosEmail
    // , getAcsUsuCmps
    // AtualizaNomUsu, AtualizaNomGrp
} from "./authActions"

import minhaImagem from "../../src/figuras/TelaEntrada.png"

import Messages from "../modules/common/messages/messages"

import { Modal } from "react-bootstrap"

class Auth extends Component {
    constructor(props) {
        super(props)

        this.state = {
            login: "", senha: ""
            , isModalOpen: 0
            , emailenvio: ""
            , MsgModal2: ""
        };

        this.atualizabackend();
        this.atualizabackend = this.atualizabackend.bind(this);

        this.logar = this.logar.bind(this);
        this.atualizaLogin = this.atualizaLogin.bind(this);
        this.atualizaSenha = this.atualizaSenha.bind(this);
        this.atualizaLoginEmail = this.atualizaLoginEmail.bind(this);
        this.chamaEnvioEmail = this.chamaEnvioEmail.bind(this);
        this.OpenModalParam = this.OpenModalParam.bind(this);

        //  this.AcessosEmailSlv = this.AcessosEmailSlv.bind(this)
    }

    openModal = (vrmodal) => this.setState({ isModalOpen: vrmodal });
    closeModal = () => this.setState({ isModalOpen: 0 });

    OpenModalParam() {
        this.openModal(1)
    }

    logar() {
        if (this.state.login === undefined || this.state.login === "") {
            toastr.warning("Email não informado !!!");
        }
        else {
            if (this.state.senha === undefined || this.state.senha === "") {
                toastr.warning("Senha não informada !!!");
            }

            else {
                if (this.props.VersaoBackEnd === undefined) {
                    toastr.warning("Atenção Versão do Back End não localizada, há algum problema (servidor/rede) !!!");
                } else {
                    this.setState({
                        MsgModal2: "Acessando ao Sistema..."
                    });
                    this.openModal(2);

                    setTimeout(() => {
                        this.closeModal();
                            this.props.ValidaAcesso({
                                login: this.state.login,
                                senha: this.state.senha
                            });
                        
                    }, 3000);

                    // this.setState({
                    //     isModalOpen: 0
                    // });
                    // if (this.props.RespErrologin !== "0") 
                    // {
                    //         toastr.warning(this.props.RespErrologin)
                    // }
                    // else{
                    // this.nomeusuario();
                    // this.buscaAcessoUsuarios();
                    // this.AcessosEmailSlv();
                    // }
                }
            }
        }
    }

    atualizabackend() {
        this.props.VersaoBackEndyy();
    }

    // nomeusuario() {
    //     this.props.ShowUsuario(this.state.login);
    // }

    // buscaAcessoUsuarios() {
    //     //alert("teste01: " + this.state.login)
    //     if (this.state.login !== "" && this.state.login !== undefined) {
    //         this.props.CarregaAcessoUsuarios(this.state.login);
    //     }
    // }
    // AcessosEmailSlv() {
    //     this.props.getAcessosEmail();
    //     this.props.getAcsUsuCmps()
    // }

    atualizaLogin(e) {
        this.setState({
            login: e.target.value,
            emailenvio: e.target.value
        });
    }

    atualizaSenha(e) {
        this.setState({
            senha: e.target.value
        });
    }

    chamaEnvioEmail() {
        if (this.state.emailenvio === undefined || this.state.emailenvio === "") {
            toastr.warning("Atenção informe um E-mail para recuperação da senha !!!");
        } else {
            this.props.AActEnviaEmail(this.state.emailenvio);
        }
    }

    atualizaLoginEmail(e) {
        this.setState({
            emailenvio: e.target.value
        });
    }

    render() {

        return (
            <>
                <div className="authPrincipal"  >
                    <div className="row img-fluid " >
                        <div className="col-md-4"  >
                            <figure >
                                <img className="Responsive Image" src={minhaImagem} alt=""  ></img>
                            </figure>
                        </div>

                        <div className="col-md-4" style={{ paddingTop: "10%", paddingLeft: "5%", marginLeft: "15%" }}>
                            <div className="row">
                                <div className="card1" style={{ background: "#ffffff", borderRadius: "20px" }}>
                                    <div className="card-header" style={{
                                        background: "#ffffff", color: "#3d682b"
                                        , fontWeight: "true", fontFamily: "Barlow",
                                        fontSize: "25px", borderBottom: "none", textAlign: "center"
                                    }}>
                                        Faça Login no HeiTools
                                    </div>
                                    {/* <div style={{ marginLeft: -90 + "%", color: "#3d682b" }}>Email</div> */}
                                    <div className="form-group" style={{ fontFamily: "Barlow", color: "#3d682b" }} >
                                        Email
                                    </div>
                                    <div className="form-group" style={{ marginBottom: 20 + "px" }}>
                                        <input type="text" className="form-control" placeholder="Digite o Email"
                                            style={{ borderTop: "none", fontSize: "80%", fontFamily: "Barlow" }}
                                            value={this.state.login}
                                            onChange={this.atualizaLogin}
                                        // AdmMaster
                                        />
                                    </div>
                                    <div className="form-group" style={{ color: "#3d682b", fontFamily: "Barlow" }} >
                                        Senha
                                    </div>
                                    <div className="form-group">
                                        <input type="password" className="form-control" placeholder="Digite a Senha"
                                            style={{ borderTop: "none", fontSize: "80%", fontFamily: "Barlow" }}
                                            value={this.senha}
                                            onChange={this.atualizaSenha} />
                                    </div>
                                    <br /><br />
                                    <div className="card-footer" style={{
                                        background: "#ffffff", border: "none"
                                        , alignItems: "center"
                                    }}>
                                        <button type="button"
                                            style={{
                                                background: "#3d682b"
                                                , color: "#ffffff"
                                                , paddingInline: 49 + "%"
                                                , marginLeft: -4 + "%"
                                                , borderRadius: "6px"
                                            }}
                                            onClick={this.logar}
                                        >
                                            Entrar</button>
                                        <br />
                                        <br />
                                        <div style={{ color: "#3d682b", textAlign: "center" }}>
                                            <button type="button" className="btn sublinhado"
                                                style={{ fontSize: "13px", fontStyle: "Italic" }}
                                                onClick={this.OpenModalParam}
                                            >Esqueci minha senha
                                            </button >

                                            <br />
                                            <br />
                                            <div className="row">
                                                <span style={{ fontSize: "9px" }}>{Ambiente}</span>
                                            </div>
                                            <br />
                                            <div className="row">
                                                <span style={{ fontSize: "9px" }}>{Versao}</span>
                                            </div>
                                            <div className="row">
                                                <span
                                                    style={(this.props.VersaoBackEnd === undefined ? { fontSize: "9px", color: 'red' } : { fontSize: "9px" })}
                                                >Versão Back End: {this.props.VersaoBackEnd}
                                                    &nbsp;&nbsp;
                                                    {(this.props.VersaoBackEnd === undefined
                                                        ? "Desconection" : "Conection")}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    size="lg"
                    show={(this.state.isModalOpen === 1 ? true : false)}
                    onHide={this.closeModal}
                >
                    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935"
                                , fontFamily: "Barlow"
                                , fontSize: "22px"
                                , fontStyle: "Italic"

                            }}
                        >Envio da Senha por E-mail </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ color: "#77b935" }}>
                        <div className="row" style={{ marginBottom: "10px" }}>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>E-mail</label>
                                    <input type="text"
                                        className="form-control"
                                        value={this.state.emailenvio}
                                        onChange={this.atualizaLoginEmail}
                                        // placeholder="digite o nome Email ou Usuário..." 
                                        maxLength="200"
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary"
                            onClick={this.closeModal}
                        >Fechar</button>
                        <button type="button" style={{ background: "#77b935" }}
                            className="btn "
                            onClick={this.chamaEnvioEmail}
                        >Enviar</button>
                    </Modal.Footer>
                </Modal>

                <Messages />
                {/*Modal leitura*/}
                <Modal size="sm" show={(this.state.isModalOpen === 2 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}

                >
                    <Modal.Body >
                        <div className="row d-flex justify-content-center" >
                            <Spinner animation="border" role="status" variant="success">
                            </Spinner>
                        </div>
                        <div className="row" style={{ textAlign: "Center" }}>
                            <i className="fa-blink "> {this.state.MsgModal2}</i>
                            {/* <span> {this.state.MsgModal2} </span> */}

                        </div>
                    </Modal.Body>

                </Modal>

            </>


        )
    }
}

const mapStateToProps = state => ({
    VersaoBackEnd: state.authRed.VersaoBackEndcc
    , CmpCodUsuario: state.authRed.CodUsuario
    // , RespErrologin: state.authRed.Errologin
})
const mapDispatchToProps = dispatch => bindActionCreators({
    ValidaAcesso
    , ShowUsuario
    , VersaoBackEndyy
    , AActEnviaEmail
    // , CarregaAcessoUsuarios
    // , getAcessosEmail
    // , getAcsUsuCmps
    //, EnderecoHTTPS

}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Auth)